import styled from 'styled-components';

export const CanvasPanel = styled.div<{
  $showAxis?: boolean;
  $maxWidth?: number;
}>`
  flex-shrink: 1;
  min-width: 360px;
  ${(p) => (p.$maxWidth !== undefined ? `max-width: ${p.$maxWidth}px;` : '')}
  padding-right: ${(p) => (p.$showAxis !== false ? '48px' : '0')};
`;

export const StyledCanvas = styled.canvas`
  display: block;
  max-width: 100%;
  height: auto;
  cursor: crosshair;
  border: 1px solid #ddd;
  border-radius: 4px;
  user-select: none;
`;

export const CanvasHint = styled.p`
  font-size: 12px;
  color: #6f6f6f;
  margin: 6px 0 0;
  text-align: center;
`;

export const CoordInfo = styled.p`
  font-size: 11px;
  font-family: monospace;
  color: #555;
  margin: 4px 0 0;
  text-align: center;
  height: 1.4em;
`;

export const LayerSliderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  padding: 7px 10px;
  background: #f7f7f7;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
`;

/** Aligns the slider to the canvas area, excluding Y-axis label and right padding. */
export const SliderAligner = styled.div<{ $active?: boolean }>`
  margin-left: ${(p) => (p.$active ? '80px' : '0')};
`;

export const RangeInput = styled.input`
  flex: 1;
  min-width: 0;
  accent-color: #007079;
  cursor: pointer;
`;

export const LayerLabel = styled.span`
  font-size: 11px;
  font-family: monospace;
  color: #3d3d3d;
  min-width: 180px;
  white-space: nowrap;
`;

export const LoadingBox = styled.div<{ width: number; height: number }>`
  width: ${(p) => p.width}px;
  max-width: 100%;
  height: ${(p) => p.height}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #6f6f6f;
`;

export const CanvasWithAxis = styled.div<{ $showAxis?: boolean }>`
  position: relative;
  display: inline-block;
  max-width: ${(p) => (p.$showAxis !== false ? 'calc(100% - 80px)' : '100%')};
  margin-left: ${(p) => (p.$showAxis !== false ? '80px' : '0')};
  margin-bottom: ${(p) => (p.$showAxis !== false ? '72px' : '0')};
`;

export const YAxisOverlay = styled.div`
  position: absolute;
  right: 100%;
  top: 0;
  height: 100%;
  width: 80px;
  pointer-events: none;
`;

export const YAxisTitle = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-family: monospace;
  font-weight: 600;
  color: #555;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
`;

export const XAxisOverlay = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 72px;
  pointer-events: none;
  margin-top: 0;
`;

export const XAxisTitle = styled.span`
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  font-family: monospace;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
`;

export const TickMark = styled.div<{ $pct: number; $axis: 'x' | 'y' }>`
  position: absolute;
  background: #888;
  ${(p) =>
    p.$axis === 'x'
      ? `left: ${p.$pct}%; top: 0; width: 1px; height: 5px; transform: translateX(-50%);`
      : `top: ${p.$pct}%; right: 0; height: 1px; width: 5px; transform: translateY(-50%);`}
`;

export const AxisTick = styled.span<{ $pct: number; $axis: 'x' | 'y' }>`
  position: absolute;
  font-size: 10px;
  font-family: monospace;
  color: #666;
  white-space: nowrap;
  ${(p) =>
    p.$axis === 'x'
      ? `left: ${p.$pct}%; top: 7px; display: inline-block; line-height: 1; transform: rotate(45deg); transform-origin: top left;`
      : `top: ${p.$pct}%; transform: translateY(-50%); right: 10px; text-align: right;`}
`;
